export default __webpack_public_path__ + "static/media/02.51d9b3d3.jpg";